export default __webpack_public_path__ + "static/media/rf-ico-active.4040da51.svg";